import { useMutation, useQueryClient } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

import { BULK_SCAN_INVENTORIES_KEY } from './useBulkScanInventoriesQuery';

/**
 * This is to track the missing inventory query from the backend.
 */
const MISSING_INVENTORY_KEY = 'missing-inventory-mutation-query';

interface IMissingInventoryMutation {
  enabled?: boolean;
  onSuccessCallback?: () => void;
}

/**
 * This hook is used to mark an inventory as missing.
 */
export const useMarkInventoryAsMissingMutation = ({
  onSuccessCallback,
}: IMissingInventoryMutation) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: markInventoryAsMissing,
    reset: resetMarkInventoryAsMissingMutation,
  } = useMutation({
    mutationKey: [MISSING_INVENTORY_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.markInventoryAsMissing,
    onSuccess: () => {
      onSuccessCallback?.();
      queryClient.invalidateQueries({ queryKey: [BULK_SCAN_INVENTORIES_KEY] });
    },
  });

  return {
    markInventoryAsMissing,
    data,
    error,
    isError,
    isPending,
    resetMarkInventoryAsMissingMutation,
  };
};
